import { render, staticRenderFns } from "./TrendyolProductItem.vue?vue&type=template&id=221c84ae&"
import script from "./TrendyolProductItem.vue?vue&type=script&lang=js&"
export * from "./TrendyolProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports